import type { Instruction } from './instructionTypes';

export const OPERATORS = {
  in: 'in',
  endsWith: 'endsWith',
  startsWith: 'startsWith',
  matches: 'matches',
  contains: 'contains',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  before: 'before',
  after: 'after',
  segmentMatch: 'segmentMatch',
  semVerEqual: 'semVerEqual',
  semVerLessThan: 'semVerLessThan',
  semVerGreaterThan: 'semVerGreaterThan',
  applicationVersionSupported: 'applicationVersionSupported',
} as const;

/**
 * Instruction kinds
 */

export const flagVariationsInstructionKinds = {
  ADD_VARIATION: 'addVariation',
  REMOVE_VARIATION: 'removeVariation',
  UPDATE_VARIATION: 'updateVariation',
  UPDATE_DEFAULT_VARIATION: 'updateDefaultVariation',
} as const;

export const ruleInstructionKinds = {
  ADD_RULE: 'addRule',
  REMOVE_RULE: 'removeRule',
  REORDER_RULES: 'reorderRules',
  UPDATE_RULE_VARIATION_OR_ROLLOUT: 'updateRuleVariationOrRollout',
  UPDATE_RULE_DESCRIPTION: 'updateRuleDescription',
  UPDATE_RULE_TRACK_EVENTS: 'updateRuleTrackEvents',
  DISABLE_RULE: 'disableRule',
  ENABLE_RULE: 'enableRule',
  STOP_MEASURED_ROLLOUT_ON_RULE: 'stopMeasuredRolloutOnRule',
  UPDATE_RULE_WITH_MEASURED_ROLLOUT_V2: 'updateRuleWithMeasuredRolloutV2',
  ADD_RULE_WITH_MEASURED_ROLLOUT_V2: 'addRuleWithMeasuredRolloutV2',
  // clauses
  ADD_CLAUSES: 'addClauses',
  REMOVE_CLAUSES: 'removeClauses',
  UPDATE_CLAUSE: 'updateClause',
  ADD_VALUES_TO_CLAUSE: 'addValuesToClause',
  REMOVE_VALUES_FROM_CLAUSE: 'removeValuesFromClause',
} as const;

export const fallthroughInstructionKinds = {
  STOP_MEASURED_ROLLOUT_ON_FALLTHROUGH: 'stopMeasuredRolloutOnFallthrough',
  UPDATE_FALLTHROUGH_VARIATION_OR_ROLLOUT: 'updateFallthroughVariationOrRollout',
  UPDATE_FALLTHROUGH_WITH_MEASURED_ROLLOUT_V2: 'updateFallthroughWithMeasuredRolloutV2',
} as const;

export const prerequisiteInstructionKinds = {
  ADD_PREREQUISITE: 'addPrerequisite',
  REMOVE_PREREQUISITE: 'removePrerequisite',
  UPDATE_PREREQUISITE: 'updatePrerequisite',
  REPLACE_PREREQUISITES: 'replacePrerequisites',
} as const;

export const replaceTargetsInstructionKind = {
  REPLACE_TARGETS: 'replaceTargets',
} as const;

export const targetInstructionKinds = {
  ADD_TARGETS: 'addTargets',
  REMOVE_TARGETS: 'removeTargets',
  CLEAR_TARGETS: 'clearTargets',
} as const;

export const allTargetInstructionKinds = {
  ...targetInstructionKinds,
  ...replaceTargetsInstructionKind,
} as const;

export const flagLevelInstructionKinds = {
  TURN_FLAG_ON: 'turnFlagOn',
  TURN_FLAG_OFF: 'turnFlagOff',
  ENABLE_TARGETING: 'enableTargeting',
  DISABLE_TARGETING: 'disableTargeting',
  UPDATE_NAME: 'updateName',
  UPDATE_DESCRIPTION: 'updateDescription',
  UPDATE_OFF_VARIATION: 'updateOffVariation',
  UPDATE_TRACK_EVENTS: 'updateTrackEvents',
  REPLACE_RULES: 'replaceRules',
  STOP_PROGRESSIVE_ROLLOUT: 'stopProgressiveRollout',
  START_AUTOMATED_RELEASE: 'startAutomatedRelease',
  STOP_AUTOMATED_RELEASE: 'stopAutomatedRelease',
  ADVANCE_AUTOMATED_RELEASE: 'advanceAutomatedRelease',
} as const;

/**
 * Instruction types
 */

export const FlagConfigInstructionTypes = {
  PREREQUISITES: 'prerequisites',
  TARGETS: 'targets',
  RULE: 'rule',
  FALLTHROUGH: 'fallthrough',
  TOGGLE_INSTRUCTIONS: 'toggleInstructions',
  TOGGLE_OFF_VARIATIONS: 'toggleOffVariations',
  ALL: 'all',
} as const;

export const FlagInstructionTypes = {
  VARIATIONS: 'variations',
  ALL: 'all',
} as const;

export const FALLTHROUGH_RULE_ID = 'fallthrough';

export const guardedRolloutInstructions: Array<Instruction['kind']> = [
  fallthroughInstructionKinds.UPDATE_FALLTHROUGH_WITH_MEASURED_ROLLOUT_V2,
  fallthroughInstructionKinds.STOP_MEASURED_ROLLOUT_ON_FALLTHROUGH,
  ruleInstructionKinds.UPDATE_RULE_WITH_MEASURED_ROLLOUT_V2,
  ruleInstructionKinds.ADD_RULE_WITH_MEASURED_ROLLOUT_V2,
  ruleInstructionKinds.STOP_MEASURED_ROLLOUT_ON_RULE,
];
